// export const PublicKeYOmise = "pkey_5w25u8jq792a6qhysh5";
export const PublicKeYOmise = "pkey_test_5sqyh88gojoro8lm6vi";

export const GOOGLE_MAPS_APIKEY = "AIzaSyBYcbzmF26_rfdB2qPF9NKz5JHYTfk8m7g";
// export const GOOGLE_MAPS_APIKEY = "AIzaSyCIdnH9jJ_mfZXIRDJpTpt_yaCyvhB4aU0";
export const ExchangeApi =
  "https://v6.exchangerate-api.com/v6/544c8c5cc34451bd08bd8d9d/latest/THB";
export const CountryCheckApi = "https://ipapi.co/json/";
export const isLive = true;

export const BASE_URL_LOCAL = "http://localhost:6001";
export const BASE_URL_LIVE = "https://darkblue-sheep-755841.hostingersite.com";
export const BASE_URL = isLive ? BASE_URL_LIVE : BASE_URL_LOCAL;
export const BASE_URL_IMAGE = BASE_URL + "/uploads/";

/*
  IMPORTANT: Case Creation with Proper Relationships
  
  When creating a new case, you should now include clientId and defaulterId:
  
  const caseData = {
    case_id: "CASE001",
    client_name: "Client Name", // Keep for display purposes
    defaulter_name: "Defaulter Name", // Keep for display purposes
    phone: "1234567890",
    financial_year: "2024-25",
    status: "pending",
    createdBy: "Staff Name",
    createdUserId: staffObjectId,
    // NEW: Proper foreign key relationships
    clientId: clientObjectId,     // ObjectId reference to clients collection
    defaulterId: defaulterObjectId // ObjectId reference to defaulters collection
  };
*/

export const END_POINT = {
  PdfFileUpload: BASE_URL + "/api/file-upload",
  VideoUpload: BASE_URL + "/api/video-upload",
  ImageUpload: BASE_URL + "/api/picture-upload",
  MoreImageUpload: BASE_URL + "/api/multiple-picture-upload",
  UploadDocument: BASE_URL + "/api/upload-recovery-document",
  ClientUploadCaseDocument: BASE_URL + "/api/client-upload-case-document",
  CreateCaseWithoutEmail: BASE_URL + "/api/create-case-without-email",
  GetHomeDirectoryData: BASE_URL + "/api/get-home-directory-data",
  UpsertHomeDirectoryData: BASE_URL + "/api/upsert-home-directory-data",
  GetBlog: BASE_URL + "/api/get-blog",
  GetBlogById: BASE_URL + "/api/get-blog-byid/",
  CreateBlog: BASE_URL + "/api/post-blog",
  UpdateBlog: BASE_URL + "/api/blog-update/",
  DeleteBlog: BASE_URL + "/api/delete-blog/",
  
  ClientUploadAgreement: BASE_URL + "/api/client-upload-agreement",

// Chat
SendChatFile: BASE_URL + "/api/chat/",
DeleteChat: BASE_URL + "/api/delete-chat/",
DeleteChatMessage: BASE_URL + "/api/delete-message/",
DeleteMultipleChat: BASE_URL + "/api/delete-multiple-messages",


  AdminLogin: BASE_URL + "/api/admin-login/",
  AdminAuthLogin: BASE_URL + "/api/auth/admin/login",
  AdminAuthSignup: BASE_URL + "/api/auth/admin/signup",

  //User

  UserRegistration: BASE_URL + "/api/user-registration/",
  UserLogin: BASE_URL + "/api/user-login/",
  ClientLogin: BASE_URL + "/api/client-login/",
  ClientAuthLogin: BASE_URL + "/api/auth/client/login",
  ClientAuthSignup: BASE_URL + "/api/auth/client/signup",
  ClientLoginOTP: BASE_URL + "/api/client-login-otp",
  RegisterClient: BASE_URL + "/api/register-client/",
  LawyerAuthLogin: BASE_URL + "/api/auth/lawyer/login",
  LawyerAuthSignup: BASE_URL + "/api/auth/lawyer/signup",

  // Client portal pages
  ClientPortalSubmitNotice: BASE_URL + "/api/client-portal/notices",
  ClientPortalPreviewNotice: BASE_URL + "/api/client-portal/notices/preview",
  ClientPortalGetNotices: BASE_URL + "/api/client-portal/notices",
  ClientPortalUpdateNotice: BASE_URL + "/api/client-portal/notices/",
  ClientPortalUpdateNoticeStatus: BASE_URL + "/api/client-portal/notices/",
  ClientPortalAssignNoticeLawyer: BASE_URL + "/api/client-portal/notices/",
  ClientPortalUpdateGeneratedNotice: BASE_URL + "/api/client-portal/notices/",
  ClientPortalUploadDocument: BASE_URL + "/api/client-portal/documents",
  ClientPortalGetDocuments: BASE_URL + "/api/client-portal/documents",
  ClientPortalUpdateDocument: BASE_URL + "/api/client-portal/documents/",
  ClientPortalCreatePayment: BASE_URL + "/api/client-portal/payments",
  ClientPortalGetPayments: BASE_URL + "/api/client-portal/payments",
  ClientPortalDeliveryTracking: BASE_URL + "/api/client-portal/delivery-tracking",
  ClientPortalDownloads: BASE_URL + "/api/client-portal/downloads",
  ClientPortalCreateNotification: BASE_URL + "/api/client-portal/notifications",
  ClientPortalGetNotifications: BASE_URL + "/api/client-portal/notifications",
  ClientPortalMarkNotificationRead: BASE_URL + "/api/client-portal/notifications/",
  ClientPortalGetProfile: BASE_URL + "/api/client-portal/profile/",
  ClientPortalUpdateProfile: BASE_URL + "/api/client-portal/profile/",
  ClientPortalCreateDefaulter: BASE_URL + "/api/client-portal/defaulters",
  ClientPortalGetDefaulters: BASE_URL + "/api/client-portal/defaulters",
  ClientPortalGetDefaulterById: BASE_URL + "/api/client-portal/defaulters/",
  ClientPortalUpdateDefaulter: BASE_URL + "/api/client-portal/defaulters/",

  // OTP Authentication
  VerifyOTP: BASE_URL + "/api/verify-otp",
  ResendOTP: BASE_URL + "/api/resend-otp",

  // Staff

  StaffLogin: BASE_URL + "/api/staff-login/",
  StaffLoginOTP: BASE_URL + "/api/staff-login-otp",
  RegisterStaff: BASE_URL + "/api/post-staff/",
  GetStaff: BASE_URL + "/api/get-staff/",
  UpdateStaff: BASE_URL + "/api/staff-update/",
  DeleteStaff: BASE_URL + "/api/delete-staff/",
  GetStaffById: BASE_URL + "/api/get-staff-byid/",
  StaffUpdateStatus: BASE_URL + "/api/update-staff-status/",




  //Defaulter

  GetDefaulter: BASE_URL + "/api/get-defaulter/",
  GetDefaulterByStaff: BASE_URL + "/api/get-defaulter-by-staff/",
  GetPendingDefaultersByBd: BASE_URL + "/api/get-pending-defaulters-by-bd/",
  UploadDefaulter: BASE_URL + "/api/post-defaulter",
  UpdateDefaulter: BASE_URL + "/api/defaulter-update/",
  DeleteDefaulter: BASE_URL + "/api/delete-defaulter/",
  GetDefaulterById: BASE_URL + "/api/get-defaulter-byid/",
  ApproveDefaulter: BASE_URL + "/api/approve-defaulter/",
  UploadDefaulterPayment: BASE_URL + "/api/post-defaulter-payment/",
  SendEmailAndCreateCase: BASE_URL + "/api/send-email-create-case",
  SaveIntimationLetter: BASE_URL + "/api/save-intimation-letter",
  GetIntimationLetters: BASE_URL + "/api/get-intimation-letters",


  // Payment

  GetPayment: BASE_URL + "/api/get-payment/",
  UploadPayment: BASE_URL + "/api/post-payment",
  UpdatePayment: BASE_URL + "/api/payment-update/",
  DeletePayment: BASE_URL + "/api/delete-payment/",
  GetPaymentById: BASE_URL + "/api/get-payment-byid/",
  GetPaymentsByCreator: BASE_URL + "/api/get-payments-by-creator/",
  GetPaymentsByCase: BASE_URL + "/api/get-payments-by-case/",
  GetPaymentsByDefaulter: BASE_URL + "/api/get-payments-by-defaulter/",


  //Clients

  GetClient: BASE_URL + "/api/get-client/",
  GetClientByStaff: BASE_URL + "/api/get-client-by-staff/",
  UploadClient: BASE_URL + "/api/post-client",
  UpdateClient: BASE_URL + "/api/client-update/",
  UpdateClientBasic: BASE_URL + "/api/update-client-basic/",
  DeleteClient: BASE_URL + "/api/delete-client/",
  GetClientById: BASE_URL + "/api/get-client-byid/",
  ImportClients: BASE_URL + "/api/post-client",
  ClientUpdateStatus: BASE_URL + "/api/update-client-status/",
  SetClientAutoAssignment: BASE_URL + "/api/set-client-auto-assignment",
  UpdateClientPriority: BASE_URL + "/api/update-client-priority",
  ApproveClient: BASE_URL + "/api/approve-client",
  RejectClient: BASE_URL + "/api/reject-client",

  // Lawyers / Advocates
  GetLawyer: BASE_URL + "/api/get-lawyer/",
  GetLawyerById: BASE_URL + "/api/get-lawyer-byid/",
  CreateLawyer: BASE_URL + "/api/create-lawyer",
  UpdateLawyer: BASE_URL + "/api/update-lawyer/",
  UpdateLawyerStatus: BASE_URL + "/api/update-lawyer-status/",
  LawyerUpdateProfile: BASE_URL + "/api/lawyer-profile/",

  // Templates
  GetTemplate: BASE_URL + "/api/get-template/",
  GetTemplateById: BASE_URL + "/api/get-template-byid/",
  CreateTemplate: BASE_URL + "/api/create-template",
  UpdateTemplate: BASE_URL + "/api/update-template/",

  // Admin documents
  GetAdminDocument: BASE_URL + "/api/get-admin-document/",
  GetAdminDocumentById: BASE_URL + "/api/get-admin-document-byid/",
  CreateAdminDocument: BASE_URL + "/api/create-admin-document",
  UpdateAdminDocument: BASE_URL + "/api/update-admin-document/",

  // PayU Payment Gateway
  PayuInitiate: BASE_URL + "/api/payu/initiate",

  // Admin payments
  GetAdminPayment: BASE_URL + "/api/get-admin-payment/",
  GetAdminPaymentById: BASE_URL + "/api/get-admin-payment-byid/",
  CreateAdminPayment: BASE_URL + "/api/create-admin-payment",
  UpdateAdminPayment: BASE_URL + "/api/update-admin-payment/",

  // Admin notices
  GetAdminNotice: BASE_URL + "/api/get-admin-notice/",
  GetAdminNoticeById: BASE_URL + "/api/get-admin-notice-byid/",
  CreateAdminNotice: BASE_URL + "/api/create-admin-notice",
  UpdateAdminNotice: BASE_URL + "/api/update-admin-notice/",

  // Admin withdrawals
  GetAdminWithdrawal: BASE_URL + "/api/get-admin-withdrawal/",
  GetAdminWithdrawalById: BASE_URL + "/api/get-admin-withdrawal-byid/",
  CreateAdminWithdrawal: BASE_URL + "/api/create-admin-withdrawal",
  UpdateAdminWithdrawal: BASE_URL + "/api/update-admin-withdrawal/",

  // Client Notifications
  GetClientNotifications: BASE_URL + "/api/notifications/",
  GetUnreadNotificationsCount: BASE_URL + "/api/notifications/",
  GetRecentClientNotifications: BASE_URL + "/api/notifications/",
  MarkNotificationAsRead: BASE_URL + "/api/notifications/",
  MarkAllNotificationsAsRead: BASE_URL + "/api/notifications/",



  // Case

  GetCase: BASE_URL + "/api/get-case/",
  GetCaseByStaff: BASE_URL + "/api/get-case-by-staff/",
  GetCasesByClient: BASE_URL + "/api/get-cases-by-client/",
  UploadCase: BASE_URL + "/api/post-case",
  UpdateCase: BASE_URL + "/api/case-update/",
  DeleteCase: BASE_URL + "/api/delete-case/",
  GetCaseById: BASE_URL + "/api/get-case-byid/",
  GetCaseWithDetails: BASE_URL + "/api/get-case-with-details/",
  GetAllCasesWithDetails: BASE_URL + "/api/get-all-cases-with-details",
  AssignCase: BASE_URL + "/api/assign-case",
  GetCasesByStaffRole: BASE_URL + "/api/get-cases-by-staff-role/",
  SelfAssignCase: BASE_URL + "/api/self-assign-case",
  UpdateCaseWorkTab: BASE_URL + "/api/case/",

  // Comment endpoints
  PostComment: BASE_URL + "/api/post-comment",
  GetCommentsByCase: BASE_URL + "/api/get-comments-by-case/",
  GetRecentComments: BASE_URL + "/api/get-recent-comments",
  GetCommentById: BASE_URL + "/api/get-comment-byid/",
  UpdateComment: BASE_URL + "/api/comment-update/",
  DeleteComment: BASE_URL + "/api/delete-comment/",

  // Reminder endpoints
  GetTodayReminders: BASE_URL + "/api/get-today-reminders/",
  GetStaffReminders: BASE_URL + "/api/get-staff-reminders/",
  StaffReminderMarkRead: BASE_URL + "/api/staff-reminders/",
  LegacyGetAdminNotifications: BASE_URL + "/api/get-admin-notifications/",
  CheckUnassignedCases: BASE_URL + "/api/check-unassigned-cases",
  GetReminderConfig: BASE_URL + "/api/get-reminder-config",

  // Refuse to Pay escalation endpoints
  GetEscalatedCases: BASE_URL + "/api/get-escalated-cases/",
  AdminDecisionOnCase: BASE_URL + "/api/admin-decision-on-case",
  DailyFollowUpCheck: BASE_URL + "/api/daily-followup-check",

  // Notice 1 workflow endpoints
  AssignCaseToNotice1BD: BASE_URL + "/api/assign-case-notice1-bd",
  GetBdNotice1Cases: BASE_URL + "/api/get-bd-notice1-cases/",
  CompleteBdNotice1: BASE_URL + "/api/complete-bd-notice1",

  // Notice 2 workflow endpoints
  AssignCaseToNotice2BD: BASE_URL + "/api/assign-case-notice2-bd",
  GetBdNotice2Cases: BASE_URL + "/api/get-bd-notice2-cases/",
  CompleteBdNotice2: BASE_URL + "/api/complete-bd-notice2",

  // Not Connected workflow endpoints
  AssignCaseToNotConnectedBD: BASE_URL + "/api/assign-case-notconnected-bd",
  GetBdNotConnectedCases: BASE_URL + "/api/get-bd-notconnected-cases/",
  CompleteBdNotConnectedPhone: BASE_URL + "/api/complete-bd-notconnected-phone",
  EscalateNotConnectedToAdmin: BASE_URL + "/api/escalate-notconnected-admin",
  GetEscalatedNotConnectedCases: BASE_URL + "/api/get-escalated-notconnected-cases/",
  AdminDecisionOnNotConnected: BASE_URL + "/api/admin-decision-notconnected",

  // Staff notifications endpoints
  GetStaffNotifications: BASE_URL + "/api/staff-notifications/",
  StaffMarkNotificationAsRead: BASE_URL + "/api/staff-notifications/",
  StaffMarkAllNotificationsAsRead: BASE_URL + "/api/staff-notifications/",

  // Task Management endpoints
  GetTasks: BASE_URL + "/api/get-tasks",
  GetMyTasks: BASE_URL + "/api/get-my-tasks/",
  GetCreatedTasks: BASE_URL + "/api/get-created-tasks/",
  CreateTask: BASE_URL + "/api/create-task",
  UpdateTask: BASE_URL + "/api/update-task/",
  DeleteTask: BASE_URL + "/api/delete-task/",
  AddTaskComment: BASE_URL + "/api/add-task-comment/",
  GetTaskStats: BASE_URL + "/api/get-task-stats",
  GetAssignableUsers: BASE_URL + "/api/get-assignable-users",

  // Add this endpoint with the other BD assignment endpoints
  AssignCaseToMissingDetailsBD: BASE_URL + "/api/assign-case-to-missingdetails-bd",

  // Add this endpoint for completing missing details work
  CompleteMissingDetailsWork: BASE_URL + "/api/complete-missing-details-work",

  // Add this endpoint for BD to complete missing details
  CompleteMissingDetails: BASE_URL + "/api/complete-missing-details",

  // Add this endpoint for negotiate amount requests
  SubmitNegotiateAmount: BASE_URL + "/api/submit-negotiate-amount",

  // Add this endpoint for admin negotiate amount decision
  AdminNegotiateAmountDecision: BASE_URL + "/api/admin-negotiate-amount-decision",

  // Add this endpoint for part payment requests
  SubmitPartPayment: BASE_URL + "/api/submit-part-payment",

  // Add this endpoint for admin part payment decision
  AdminPartPaymentDecision: BASE_URL + "/api/admin-part-payment-decision",

  // Add this endpoint for recovery done with payment creation
  SubmitRecoveryDone: BASE_URL + "/api/submit-recovery-done",

  // Recovery pages endpoints
  GetRecoveredCases: BASE_URL + "/api/get-recovered-cases",
  GetStaffRecoveredCases: BASE_URL + "/api/get-staff-recovered-cases",

  // Add this endpoint for sending legal notice emails
  SendLegalNoticeEmail: BASE_URL + "/api/send-legal-notice-email",

  // Add this endpoint for staff case insights
  GetStaffCaseInsights: BASE_URL + "/api/get-staff-case-insights/",

  // Admin notifications endpoints
  GetAdminNotifications: BASE_URL + "/api/admin-notifications/",
  AdminMarkNotificationAsRead: BASE_URL + "/api/admin-notifications/",
  AdminMarkAllNotificationsAsRead: BASE_URL + "/api/admin-notifications/",
  GetAdminNotificationStats: BASE_URL + "/api/admin-notifications/",
  CleanupOldNotifications: BASE_URL + "/api/admin-notifications/cleanup",

  // User profile endpoints
  GetUserById: BASE_URL + "/api/getuserbyid/",
  UpdateUser: BASE_URL + "/api/user-update/",

};


export const starOptions = [
  { value: "5", label: "5 stars" },
  { value: "4.5", label: "4.5 stars" },
  { value: "4", label: "4 stars" },
  { value: "3", label: "3 stars" },
  { value: "2", label: "2 stars" },
  { value: "1", label: "1 star" },
];


export const METHODS = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export const HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const reg = /^[0-9]*$/;
export const rule = /^[a-zA-Z ]{2,40}$/;
export const pattern = /[1-9]/g;
export const dn = /[A-Za-z]$/;
export const DOB_REGEX =
  /^((0[0-9])|(1[012]))-((0[1-9])|([12][0-9])|(3[01]))-((20[012]\d|19\d\d)|(1\d|2[0123]))$/;
export function numberToEnglish(n) {
  var string = n.toString(),
    units,
    tens,
    scales,
    start,
    end,
    chunks,
    chunksLen,
    chunk,
    ints,
    i,
    word,
    words,
    and = "and";

  /* Remove spaces and commas */
  string = string.replace(/[, ]/g, "");

  /* Is number zero? */
  if (parseInt(string) === 0) {
    return "zero";
  }

  /* Array of units as words */
  units = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];

  /* Array of tens as words */
  tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  /* Array of scales as words */
  scales = [
    "",
    "thousand",
    "million",
    "billion",
    "trillion",
    "quadrillion",
    "quintillion",
    "sextillion",
    "septillion",
    "octillion",
    "nonillion",
    "decillion",
    "undecillion",
    "duodecillion",
    "tredecillion",
    "quatttuor-decillion",
    "quindecillion",
    "sexdecillion",
    "septen-decillion",
    "octodecillion",
    "novemdecillion",
    "vigintillion",
    "centillion",
  ];

  /* Split user argument into 3 digit chunks from right to left */
  start = string.length;
  chunks = [];
  while (start > 0) {
    end = start;
    chunks.push(string.slice((start = Math.max(0, start - 3)), end));
  }

  /* Check if function has enough scale words to be able to stringify the user argument */
  chunksLen = chunks.length;
  if (chunksLen > scales.length) {
    return "";
  }

  /* Stringify each integer in each chunk */
  words = [];
  for (i = 0; i < chunksLen; i++) {
    chunk = parseInt(chunks[i]);

    if (chunk) {
      /* Split chunk into array of individual integers */
      ints = chunks[i].split("").reverse().map(parseFloat);

      /* If tens integer is 1, i.e. 10, then add 10 to units integer */
      if (ints[1] === 1) {
        ints[0] += 10;
      }

      /* Add scale word if chunk is not zero and array item exists */
      if ((word = scales[i])) {
        words.push(word);
      }

      /* Add unit word if array item exists */
      if ((word = units[ints[0]])) {
        words.push(word);
      }

      /* Add tens word if array item exists */
      if ((word = tens[ints[1]])) {
        words.push(word);
      }

      /* Add 'and' string after units or tens integer if: */
      if (ints[0] || ints[1]) {
        /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
        if (ints[2] || (!i && chunksLen)) {
          words.push(and);
        }
      }

      /* Add hundreds word if array item exists */
      if ((word = units[ints[2]])) {
        words.push(word + " hundred");
      }
    }
  }

  return words.reverse().join(" ");
}
export const NumberSeprator = (num) => {
  return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};
export const hotelstarratingOptions = [
  { value: "3", label: "3" },
  { value: "3.5", label: "3.5" },
  { value: "4", label: "4" },
  { value: "4.5", label: "4.5" },
  { value: "5", label: "5" },
];
export const hotelTypeOptions = [
  { value: "Hotel", label: "Hotel" },
  { value: "Serenade", label: "Serenade" },
];
export const hotelpromo_type = [
  { value: "Normal", label: "Normal" },
  { value: "Best Seller", label: "Best Seller" },
  { value: "Promotion of month", label: "Promotion of month" },
];
export const hotelproductTypeOptions = [
  { value: `"Bhatrat's choice`, label: `"Bhatrat's choice` },
  { value: "SHA+ Standard", label: "SHA+ Standard" },
  { value: "Kid Friendly", label: "Kid Friendly" },
];
export const hotelplaceoffers = [
  { value: "Swimming pool", label: "Swimming pool" },
  { value: "Fitness center", label: "Fitness center" },
  { value: "Lotus spa", label: "Lotus spa" },
  { value: "Restaurant & Lounge", label: "Restaurant & Lounge" },
  { value: "Security parking", label: "Security parking" },
  { value: "Meetings & seminars", label: "Meetings & seminars" },
  { value: "Events & weddings", label: "Events & weddings" },
  { value: "Business Centre", label: "Business Centre" },
  { value: "CCTV", label: "CCTV" },
  { value: "Kid's Pool", label: "Kid's Pool" },
  { value: "Outdoor Pool", label: "Outdoor Pool" },
];

export const pricestockbenefitOptions = [
  { value: "Breakfast Included", label: "Breakfast Included" },
  { value: "Best rate Guarantee", label: "Best rate Guarantee" },
  { value: "Instant Confirmation", label: "Instant Confirmation" },
  { value: "Breakfast & Dinner", label: "Breakfast & Dinner" },

  { value: "ABF, Lunch,Dinner", label: "ABF, Lunch,Dinner" },
];
export const pricestockpaymentmethod = [
  { value: "Pay Now", label: "Pay Now" },
  { value: "No Payment", label: "No Payment" },
  { value: "Pay Later", label: "Pay Later" },
  { value: "Pay at Property", label: "Pay at Property" },
];
export const pricestockbookingtype = [
  { value: "Instant", label: "Instant" },
  { value: "Serenade", label: "Serenade" },
];
export const pricestockcampaignname = [
  { value: "Room Only", label: "Room Only" },
  { value: "Room with Breakfast", label: "Room with Breakfast" },
  { value: "Room with Half Board", label: "Room with Half Board" },
  { value: "Room with Full Board", label: "Room with Full Board" },
];

export const wedding_view_type = [
  { value: "Desktop", label: "Desktop" },
  { value: "Mobile", label: "Mobile" },
];

export const diningTypeOptions = [
  { value: "Ala Carte", label: "Ala Carte" },
  { value: "Buffet", label: "Buffet" },
];

export const ItemTypeOptions = [
  { value: "Meal", label: "Meal" },
  { value: "Vehicle", label: "Vehicle" },
  { value: "Other", label: "Other" },
];
